/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockContent } from '../../models/block-content';

export interface ApiMasterBlockContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterBlockContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterBlockContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterBlockContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlockContent>;
    })
  );
}

apiMasterBlockContentGetByIdGet.PATH = '/api/Master/BlockContent/GetById';
